var _title, _desc, _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEditField = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Edit")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Edit")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M2.25,12.9393753 L2.25,15.7518754 L5.06250008,15.7518754 L13.3575003,7.45687517 L10.5450002,4.64437509 L2.25,12.9393753 Z M15.5325,5.28187497 C15.825,4.98937497 15.825,4.51687498 15.5325,4.22437498 L13.7775001,2.469375 C13.4850001,2.176875 13.0125001,2.176875 12.7200001,2.469375 L11.3475001,3.84187498 L14.1600001,6.65437496 L15.5325,5.28187497 Z",
    id: "edit-field-path"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02.-Site-Icons",
    transform: "translate(-257.000000, -810.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic/Edit_Field",
    transform: "translate(255.000000, 808.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_mode_edit_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-edit-field",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#edit-field-path"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "c/grey/600",
    mask: "url(#mask-edit-field)",
    fill: "#0B6FBE"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Shape",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEditField, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit-field.d45ef6e5.svg";
export { ForwardRef as ReactComponent };